import {
  Box,
  Card,
  //   CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  SvgIcon,
} from '@mui/material';
import { ReactComponent as TotalVulnerabilities } from 'assets/images/total-Vulnerabilities.svg';
import { ReactComponent as OpenVulnerabilities } from 'assets/images/open-Vulnerabilities.svg';
import { ReactComponent as CriticalVulnerabilities } from 'assets/images/critical-Vulnerabilities.svg';

import { useCallback, useEffect, useState } from 'react';
// import EmptyPlaceholder from 'shared/components/EmptyPlaceholder';
import { VulnerabilityService } from 'services/VulnerabilityService';
import VulnerabilityCharts from './VulnerabilityCharts';
import UpcomingRemediationDeadlines from './UpcomingRemediationDeadlines';

const CardGlobe: CardBiometric = CardHeader;

export interface StatusWise {
  status: string;
  count: number;
  percentage: number;
}

interface RiskRatingWise {
  count: number;
  risk_rating: string;
}

export interface Counts {
  total: number;
  open: number;
  critical: number;
}

export interface DashboardData {
  counts: Counts;
  statusWise: StatusWise[];
  riskRatingWise: RiskRatingWise[];
  remediationDeadlines: any[];
}

export interface ApiResponse {
  msg: string;
  data: DashboardData;
}

const DashboardCard: React.FC<any> = () => {
  const handleGlobeStatus = useCallback(() => {}, []);
  const [dashboardData, setDashboardData] = useState<DashboardData>({
    counts: { total: 0, open: 0, critical: 0 },
    statusWise: [],
    riskRatingWise: [],
    remediationDeadlines: [],
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchDashboardData = useCallback((): void => {
    setIsLoading(true);
    VulnerabilityService.getDashboard()
      .then(({ data: { data } }: { data: ApiResponse }) => {
        setDashboardData({
          counts: data.counts || { total: 0, open: 0, critical: 0 },
          statusWise: data.statusWise || [],
          riskRatingWise: data.riskRatingWise || [],
          remediationDeadlines: data.remediationDeadlines || [],
        });
      })
      .catch((error) => {
        console.error('Failed to fetch dashboard data:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  const totalVulnerabilities = dashboardData.counts.total;
  const openVulnerabilities = dashboardData.counts.open;
  const criticalVulnerabilities = dashboardData.counts.critical;
  return (
    <>
      {isLoading && (
        <Box className="empty-content">
          <CircularProgress />
        </Box>
      )}
      {!isLoading && (
        <Grid container className="grid-dashboard">
          <Grid item md={4} xs={12}>
            <Card variant="outlined" className="total-vulnerabilities">
              <CardGlobe
                title="Total Vulnerabilities"
                // subheader="0"
                subheader={
                  <Box mt={2}>
                    <b
                      style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        color: '#3D3C42',
                      }}
                    >
                      {totalVulnerabilities.toString()}
                    </b>
                  </Box>
                }
                titleTypographyProps={{
                  component: Chip,
                  label: 'Total Vulnerabilities',
                  clickable: false,
                  variant: 'outlined',
                  onDelete: handleGlobeStatus,
                  deleteIcon: (
                    <IconButton disabled>
                      <SvgIcon
                        component={TotalVulnerabilities}
                        inheritViewBox
                        className="view-icon"
                        fontSize="inherit"
                      />
                    </IconButton>
                  ),
                }}
              />
            </Card>
          </Grid>
          <Grid item md={4} xs={12}>
            <Card variant="outlined" className="open-vulnerabilities">
              <CardGlobe
                title="Open Vulnerabilities"
                // subheader="0"
                subheader={
                  <Box mt={2}>
                    <b
                      style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        color: '#3D3C42',
                      }}
                    >
                      {openVulnerabilities.toString()}
                    </b>
                  </Box>
                }
                titleTypographyProps={{
                  component: Chip,
                  label: 'Open Vulnerabilities',
                  clickable: false,
                  variant: 'outlined',
                  onDelete: handleGlobeStatus,
                  deleteIcon: (
                    <IconButton disabled>
                      <SvgIcon
                        component={OpenVulnerabilities}
                        inheritViewBox
                        className="view-icon"
                        fontSize="inherit"
                      />
                    </IconButton>
                  ),
                }}
              />
            </Card>
          </Grid>
          <Grid item md={4} xs={12}>
            <Card variant="outlined" className="critical-vulnerabilities">
              <CardGlobe
                title="Critical Vulnerabilities"
                // subheader="0"
                subheader={
                  <Box mt={2}>
                    <b
                      style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        color: '#3D3C42',
                      }}
                    >
                      {criticalVulnerabilities.toString()}
                    </b>
                  </Box>
                }
                titleTypographyProps={{
                  component: Chip,
                  label: 'Critical Vulnerabilities',
                  clickable: false,
                  variant: 'outlined',
                  onDelete: handleGlobeStatus,
                  deleteIcon: (
                    <IconButton disabled>
                      <SvgIcon
                        component={CriticalVulnerabilities}
                        inheritViewBox
                        className="view-icon"
                        fontSize="inherit"
                      />
                    </IconButton>
                  ),
                }}
              />
            </Card>
          </Grid>
          <VulnerabilityCharts data={dashboardData} loading={isLoading} />
          <Grid item md={12} xs={12}>
            <UpcomingRemediationDeadlines
              data={dashboardData.remediationDeadlines}
              loading={false}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default DashboardCard;
